import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ProductVariantShort } from 'src/app/common/common-product/models/product-short.model';
import { Product } from '../../models/product.model';
import { Contract } from 'src/app/snatch/models/contract.model';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Profile } from 'src/app/common/common-profile/models/profile.model';
import { AuthTokenState } from 'src/app/auth/state/auth-token.state';
import { AddLineItemToShoppingCart } from 'src/app/shopping-cart/actions/shopping-cart.actions';

@Component({
  selector: 'leap-bottom-anchor',
  templateUrl: './bottom-anchor.component.html',
  styleUrls: ['./bottom-anchor.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomAnchorComponent implements OnInit {

  @Input() selectedVariant: ProductVariantShort;
  @Input() profile: Profile;
  @Input() userDetails: any;
  @Input() expiringContract: Contract;

  @Input() restricted: boolean;

  @Select((state: any) => state.productDetails.details)
  product$: Observable<Product>;

  @Select(AuthTokenState.isLogged)
  isLogged$: Observable<boolean>;

  @Select((state: any) => state.core.dictionaries.currencySignsMap)
  currencySignsMap$: Observable<Map<string, string>>;
  @Select((state: any) => state.shoppingCart.addLineItemPending)
  addLineItemPending$: Observable<boolean>;
  
  constructor(private store: Store) { }

  ngOnInit() {
  }

  addToCart() {
    this.store.dispatch(new AddLineItemToShoppingCart(this.selectedVariant.sku, 1))
  }

}
